module.exports = __webpack_public_path__ + "static/media/projectsImage2.1991da9f.jpg";